module.exports = __webpack_public_path__ + "1.5.0-unryo/img/vmware.7c66b38a.svg";